import React, { Component } from "react";

import { Link } from "react-router-dom";

class TravelRequestCreateStep4 extends Component {
  renderStep(no, title, status, active, completed) {
    return (
      <div style={stepItem}>
        <div
          style={{
            ...stepCircle,
            background: completed ? "#10B981" : active ? "#1464E9" : "#E5E7EB",
            color: completed || active ? "#fff" : "#64748B",
          }}
        >
          {completed ? "✓" : no}
        </div>
        <div>
          <div style={{ fontWeight: 800 }}>{title}</div>
          <div style={{ fontSize: 12, color: "#64748B" }}>{status}</div>
        </div>
      </div>
    );
  }

  renderDoc(label, required, status) {
    return (
      <div style={docRow}>
        <div>
          <div style={{ fontWeight: 700 }}>
            {required && <span style={{ color: "#DC111C" }}>* </span>}
            {label}
          </div>
          <div style={docSub}>Required supporting document</div>
        </div>

        <span style={statusBadge(status)}>{status}</span>
      </div>
    );
  }

  renderFile(name) {
    return (
      <div style={fileRow}>
        <div>
          <div style={{ fontWeight: 700 }}>{name}</div>
          <div style={docSub}>PDF · 300KB</div>
        </div>

        <div style={{ display: "flex", gap: 8 }}>
          <button style={iconBtn}>👁</button>
          <button style={iconBtn}>🗑</button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div style={page}>

        {/* HEADER */}
        <h3>Create Travel Request</h3>
        <p style={sub}>Step 4 of 5 · Documents</p>

        {/* STEPPER */}
        <div style={stepWrapper}>
          {this.renderStep(1, "Traveler", "Done", false, true)}
          {this.renderStep(2, "Schedule", "Done", false, true)}
          {this.renderStep(3, "Cash Advance", "Done", false, true)}
          {this.renderStep(4, "Documents", "In Progress", true, false)}
          {this.renderStep(5, "Review", "Pending", false, false)}
        </div>

        <div style={layout}>

          {/* LEFT */}
          <div>

            {/* REQUIRED */}
            <div style={card}>
              <h4>Required Documents</h4>

              {this.renderDoc("Event invitation / agenda", true, "Uploaded")}
              {this.renderDoc("Travel itinerary", true, "Uploaded")}
              {this.renderDoc("Hotel quotation", true, "Uploaded")}
              {this.renderDoc("Purpose document", true, "Uploaded")}
              {this.renderDoc("Passport / visa copy", true, "Uploaded")}
            </div>

            {/* OPTIONAL */}
            <div style={card}>
              <h4>Booking Documents (After Approval)</h4>

              {this.renderDoc("Flight booking", false, "Pending")}
              {this.renderDoc("Hotel booking", false, "Pending")}
              {this.renderDoc("Insurance", false, "Pending")}
            </div>

            {/* UPLOAD */}
            <div style={upload}>
              <div style={{ fontSize: 32 }}>☁</div>
              <div style={{ fontWeight: 700, marginTop: 6 }}>
                Drag & drop or click to upload
              </div>
              <div style={docSub}>
                PDF / JPG / PNG · max 10MB
              </div>
            </div>

            {/* FILE LIST */}
            <div style={card}>
              <h4>Uploaded Files</h4>

              {this.renderFile("Event_Invitation.pdf")}
              {this.renderFile("Travel_Itinerary.pdf")}
              {this.renderFile("Hotel_Quotation.pdf")}
              {this.renderFile("Passport.pdf")}
            </div>

          </div>

          {/* RIGHT */}
          <div>

            <div style={card}>
              <h4>Workflow</h4>
              <p style={docSub}>
                Admin will arrange bookings after approval.
              </p>
              <hr />
              <p style={docSub}>
                Finance processes payment after booking confirmation.
              </p>
            </div>

            <div style={card}>
              <h4>Process</h4>

              {this.process("Manager Approval")}
              {this.process("Admin Booking")}
              {this.process("Finance Payment")}
              {this.process("Claim")}
            </div>

          </div>
        </div>

        {/* FOOTER */}
        <div style={footer}>
          <Link to="/travel/create/step-3" style={secondaryButtonLink}>
            ← Back
          </Link>
          <div style={{ display: "flex", gap: 10 }}>
            <button style={secondaryButton}>Save Draft</button>
            <Link to="/travel/create/step-5" style={primaryButtonLink}>
              Next →
            </Link>
          </div>
        </div>
      </div>
    );
  }

  process(text) {
    return (
      <div style={{ marginBottom: 10, fontSize: 13 }}>
        • {text}
      </div>
    );
  }
}

/* ================= STYLES ================= */

const page = {
  padding: 24,
};

const sub = {
  color: "#64748B",
  fontSize: 13,
};

const layout = {
  display: "grid",
  gridTemplateColumns: "2fr 1fr",
  gap: 20,
};

const card = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 10,
  padding: 16,
  marginBottom: 16,
};

const docRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 0",
  borderBottom: "1px solid #F1F5F9",
};

const docSub = {
  fontSize: 12,
  color: "#64748B",
};

const statusBadge = (status) => ({
  background: status === "Uploaded" ? "#ECFDF3" : "#FFF7E6",
  color: status === "Uploaded" ? "#027A48" : "#B76E00",
  padding: "4px 8px",
  borderRadius: 6,
  fontSize: 11,
  fontWeight: 700,
});

const upload = {
  border: "2px dashed #93C5FD",
  borderRadius: 10,
  padding: 30,
  textAlign: "center",
  marginBottom: 16,
};

const fileRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: 10,
  marginBottom: 8,
};

const iconBtn = {
  border: "1px solid #CBD5E1",
  background: "#fff",
  borderRadius: 6,
  width: 28,
  height: 28,
};

const stepWrapper = {
  display: "flex",
  gap: 12,
  background: "#fff",
  padding: 16,
  borderRadius: 10,
  border: "1px solid #E5E7EB",
  marginBottom: 20,
};

const stepItem = {
  display: "flex",
  gap: 10,
  alignItems: "center",
  flex: 1,
};

const stepCircle = {
  width: 32,
  height: 32,
  borderRadius: "50%",
  textAlign: "center",
  lineHeight: "32px",
  fontWeight: 800,
};

const footer = {
  marginTop: 20,
  display: "flex",
  justifyContent: "space-between",
};

const btnPrimary = {
  background: "#1464E9",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "10px 20px",
  fontWeight: 800,
};

const btnOutline = {
  border: "1px solid #CBD5E1",
  background: "#fff",
  borderRadius: 8,
  padding: "10px 20px",
};

const primaryButton = {
  background: "#1464E9",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "12px 28px",
  fontWeight: 900,
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "11px 24px",
  fontWeight: 800,
};

const primaryButtonLink = {
  ...primaryButton,
  textDecoration: "none",
  display: "inline-block",
};

const secondaryButtonLink = {
  ...secondaryButton,
  textDecoration: "none",
  display: "inline-block",
};

export default TravelRequestCreateStep4;